// extracted by mini-css-extract-plugin
export var container = "styles-module--container--2147d";
export var description = "styles-module--description--35167";
export var desktop = "1340px";
export var giant = "2200px";
export var imageContainer = "styles-module--imageContainer--a1444";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var mobile = "400px";
export var price = "styles-module--price--a3651";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var strikethrough = "styles-module--strikethrough--7a99a";
export var tablet = "769px";
export var textContainer = "styles-module--textContainer--f97be";